<template>
  <v-menu v-if="changeDeliveryStateFlag" offset-y :disabled="isBreakTime">
    <template v-slot:activator="{on}">
      <v-chip v-on="on" :class="chipColor" dark>{{ chipName }}</v-chip>
    </template>
    <v-list flat>
      <v-list-item
          v-if="deliveryState === 'dvry_to_be_done'"
          active-class="border"
          @click="onChangeDeliveryState('dvry_wait_assignment')">
        <v-icon color="dark3Grey">update</v-icon>
        <v-list-item-title class="pl-1"> 배차 취소</v-list-item-title>
      </v-list-item>
      <v-list-item
          v-if="deliveryState === 'dvry_admin_cancel'"
          active-class="border"
          @click="onChangeDeliveryState('dvry_user_cancel')">
        <v-icon color="dark3Grey"> close</v-icon>
        <v-list-item-title class="pl-1"> 무단 취소</v-list-item-title>
      </v-list-item>
      <v-list-item
          v-if="deliveryState === 'dvry_user_cancel'"
          active-class="border"
          @click="onChangeDeliveryState('dvry_admin_cancel')">
        <v-icon color="dark3Grey"> close</v-icon>
        <v-list-item-title class="pl-1"> 정상 취소</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-menu v-else offset-y>
    <template v-slot:activator="{on}">
      <v-chip v-on="on" :class="chipColor" dark>{{ chipName }}</v-chip>
    </template>
    <v-list v-if="deliveryState === 'dvry_wait_assignment' && deliveryStateEventFlag" flat>
      <v-list-item active-class="border" @click="onReReservation('manual')">
        <v-icon color="dark3Grey"> update</v-icon>
        <v-list-item-title class="pl-1"> 수동배차</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>

export default {
  name: 'CDeliveryStateChip',
  props: {
    delivery: {
      type: Object
    },
    deliveryStateEventFlag: {
      type: Boolean
    }
  },
  data() {
    return {
    }
  },
  computed: {
    status() {
      if (this.delivery)
        return this.delivery.state || this.delivery.status;
      else
        return null
    },
    deliveryState() {
      if (this.status)
        return this.status.configValue;
      else
        return null;
    },
    chipColor() {
      if (this.deliveryState === 'dvry_to_be_done') {
        // 배송예정
        return 'light1Green'
      } else if (this.deliveryState === 'dvry_done') {
        // 배송완료
        return 'light2Blue'
      } else if (this.deliveryState === 'dvry_wait_assignment') {
        // 배차대기
        return 'light1Red';
      } else if (this.deliveryState === 'dvry_user_cancel') {
        // 무단취소
        return 'red';
      } else if (this.deliveryState === 'dvry_admin_cancel') {
        // 정상취소
        return 'light2Grey';
      } else {
        return 'red';
      }
    },
    chipName() {
      if (!this.delivery)
        return ''

      return this.status.configName;
    },
    isBreakTime() {
      return this.delivery && this.delivery.departure === '휴식' && this.delivery.destination === '휴식';
    },
    changeDeliveryStateFlag() {
      return this.deliveryStateEventFlag && this.delivery
          && (this.deliveryState === 'dvry_to_be_done'
              || this.deliveryState === 'dvry_user_cancel'
              || this.deliveryState === 'dvry_admin_cancel');
    },
  },
  methods: {
    onChangeDeliveryState(state) {
      this.$emit('onChangeDeliveryState', state, this.delivery)
    },
    onReReservation(type) {
      this.$emit('onReReservation', type, this.delivery)
    }
  },
}
</script>